export default "__VITE_ASSET__DKc$jUDv__"